<template>
    <welcome/>
</template>

<script>
    import Welcome from './components/Welcome';

    export default {
        name: "Default",
        components: {
            'welcome': Welcome
        }
    }


</script>

